import { Link, useNavigate } from 'react-router-dom';
import { categories } from '@/mocks/navigation';

export default function CategoryNav() {
  const navigate = useNavigate();

  return (
    <section className="py-10 md:py-14">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-8">
          <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-900">网站分类导航</h2>
          <p className="mt-2 text-sm text-foreground-600">按类别浏览，快速找到你需要的网站</p>
        </div>

        <div className="grid grid-cols-3 sm:grid-cols-4 md:grid-cols-6 gap-3 md:gap-4">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
              className="flex flex-col items-center gap-2.5 p-4 rounded-xl bg-background-50 border border-background-200/70 hover:border-primary-300 hover:bg-primary-50/30 transition-all duration-200 group cursor-pointer"
            >
              <div className="w-11 h-11 md:w-12 md:h-12 rounded-xl bg-primary-100 flex items-center justify-center group-hover:bg-primary-200 transition-colors">
                <i className={`${cat.icon} text-primary-600 text-xl md:text-2xl`}></i>
              </div>
              <span className="text-xs md:text-sm font-medium text-foreground-700 group-hover:text-primary-600 transition-colors whitespace-nowrap">
                {cat.name}
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}